import { Button, Collapse } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

interface Props {
  renderButtonContent: (isExpanded: boolean) => JSX.Element;
}

// Component that handle expandable content but let parent customize button content
export const ExpandableContent: React.FunctionComponent<Props> = ({ renderButtonContent, children }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <StyledButton disableRipple={true} onClick={handleToggle}>
        {renderButtonContent(isExpanded)}
      </StyledButton>
      <Collapse in={isExpanded}>{children}</Collapse>
    </div>
  );
};

const StyledButton = styled(Button)`
  && {
    padding: 0;
    text-transform: none;
    width: 100%;

    :hover {
      background: none;
    }
  }
`;
